import { LicenceModel } from '@klab-berlin/api-sdk/lib/types/responses/Billing';
import { userType, packageLicenceIds } from '../../constants';
const { meinUnterrichtPro, meineFortbildung, meinUnterricht360, meinUnterricht360ForDocumentUsers } = packageLicenceIds;

export  const isLicenceIdCurrentUserPlan = (type: number, licenceId: number) => {
  const currentPlans = {
    [userType.document]: [meinUnterrichtPro],
    [userType.courses]: [meineFortbildung],
    [userType.kombi]: [meinUnterricht360, meinUnterricht360ForDocumentUsers],
  };
  
  const userPlans = currentPlans[type];
  
  return userPlans?.includes(licenceId);
};

// This function is used to order the plans based on the user type
export const orderPlans = (plans: LicenceModel[], type: number | undefined) => {
  const order: { [key: number]: number[] } = {
    [userType.basis]: [meineFortbildung, meinUnterrichtPro, meinUnterricht360],
    [userType.document]: [meinUnterrichtPro, meinUnterricht360ForDocumentUsers],
    [userType.courses]: [meineFortbildung, meinUnterricht360],
    [userType.kombi]: [meinUnterricht360]
  };
  
  const userTypeOrder = type ? order[type] : [];
  
  return plans.sort((a, b) => {
    const indexA = userTypeOrder.indexOf(a.licenceModelId);
    const indexB = userTypeOrder.indexOf(b.licenceModelId);

    const bothNotInOrder = indexA === -1 && indexB === -1; // Both items are not in the userTypeOrder array
  
    if (bothNotInOrder) {
      return 0; // Maintain the relative order of items not in the userTypeOrder array
    }
    return indexA - indexB; // Sort items based on their index in the userTypeOrder array
  });
};
